export default [
	{
		path: '/mallStore',
		name: 'MallStore',
		redirect: '/mallStore/index',
		component: () => import('@/views/mallStore/index.vue'),
		meta: { title: '应用商城', whiteListed: false },
		children: [
			{
				path: 'index',
				name: 'MoreMall',
				component: () => import('@/views/mall/shop/moreMall.vue'),
				meta: { title: '更多商城', whiteListed: true }
			},
			{
				path: 'purchase',
				name: 'MallPurchase',
				component: () => import('@/views/mall/purchase/index.vue'),
				meta: { title: '购买流程', whiteListed: false }
			},
			{
				path: 'goods-signature/:id',
				name: 'MallGoodsSignature',
				component: () => import('@/views/mall/goodsDetail/goodsSignature.vue'),
				meta: { title: '商品详情', whiteListed: true }
			},
			{
				path: 'goods-propaganda/:id',
				name: 'MallGoodsPropaganda',
				component: () => import('@/views/mall/goodsDetail/goodsPropaganda.vue'),
				meta: { title: '商品详情', whiteListed: true }
			},
			{
				path: 'goods-corporate/:id',
				name: 'MallGoodsCorporate',
				component: () => import('@/views/mall/goodsDetail/goodsCorporate.vue'),
				meta: { title: '商品详情', whiteListed: true }
			},
			{
				path: 'goods-customized/:id',
				name: 'MallGoodsCustomized',
				component: () => import('@/views/mall/goodsDetail/goodsCustomized.vue'),
				meta: { title: '商品详情', whiteListed: true }
			}
		]
	}
]
